import { render, staticRenderFns } from "./rulerH.vue?vue&type=template&id=72bdd98b&scoped=true&"
import script from "./rulerH.vue?vue&type=script&lang=js&"
export * from "./rulerH.vue?vue&type=script&lang=js&"
import style0 from "./rulerH.vue?vue&type=style&index=0&id=72bdd98b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bdd98b",
  null
  
)

export default component.exports